module.exports = __webpack_public_path__ + "img/3.8a3346c9.png";